module.exports = __webpack_public_path__ + "media/src/images/arrow__questionBack--dark-67e2fd9aec20f8db94c521d36411a1d6.png";